var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "col-12" }, [
      _vm.label
        ? _c("label", { staticClass: "data-label" }, [
            _vm._v(_vm._s(_vm.label))
          ])
        : _vm._e()
    ]),
    _c(
      "div",
      { staticClass: "col-12", class: _vm.containerClass },
      [
        _vm._l(_vm.options, function(option, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "custom-control custom-radio",
              class: { "custom-control-inline": _vm.isInline }
            },
            [
              _c("input", {
                staticClass: "custom-control-input",
                class: { invalid: _vm.error },
                attrs: {
                  id: _vm.name + option.value,
                  disabled: _vm.isDisabled,
                  name: _vm.name,
                  type: "radio"
                },
                domProps: {
                  checked: _vm.value === option.value,
                  value: option.value
                },
                on: {
                  input: function($event) {
                    return _vm.updateValue($event.target.value)
                  }
                }
              }),
              _c(
                "label",
                {
                  staticClass: "custom-control-label",
                  class: { invalid: _vm.error },
                  attrs: { for: _vm.name + option.value }
                },
                [_vm._v(" " + _vm._s(option.label) + " ")]
              )
            ]
          )
        }),
        _vm.error
          ? _c("error", {
              attrs: { message: _vm.customErrorMsg, variant: "no-border" }
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }